import { useExperimentFlags } from '@hungryroot/experiments';

/**
 * Exp 195 Food Profile warning UX (named Contains, dietary+never stack, V12
 * ingredient dislikes). Control / v10 keep legacy single-winner banners.
 *
 * Gate destination surfaces on `isVariant1` / `isVariant12` — never bare
 * `isVariant` (see Exp 195 registry notes).
 */
export function useExp195FoodProfileWarnings(): {
  isLoading: boolean;
  /** v1 or v12 — stacked/named Food Profile never warnings */
  isEnabled: boolean;
  /** v12 only — nevered_ingredients products lookup */
  isVariant12: boolean;
} {
  const exp195 = useExperimentFlags(195);

  if (exp195.isLoading || exp195.destinationFoodProfileExp195 == null) {
    return {
      isLoading: exp195.isLoading,
      isEnabled: false,
      isVariant12: false,
    };
  }

  const { isVariant1, isVariant12 } = exp195.destinationFoodProfileExp195;

  return {
    isLoading: false,
    isEnabled: isVariant1 || isVariant12,
    isVariant12,
  };
}
